<template>
  <div>
    <!-- Intro -->
    <div class="">
      <div class="mb-lg has-text-centered">
        <p class="has-text-weight-bold is-size-5">Onboarding Support Team</p>
        <p class="has-text-grey-light">Question #1 of 3</p>
      </div>
      <div>
        <p class="has-text-weight-bold has-text-centered mb-lg">
          How valuable was the training, demonstrations, and onboarding guidance provided
          by your onboarding support team?
        </p>
        <div class="columns is-centered is-marginless is-mobile">
          <div class="column is-narrow">
            <b-rate :max="5" v-model="score" size="is-large"></b-rate>
          </div>
        </div>
        <div class="has-text-centered mb-xl">
          <p class="has-text-grey-light mb-xl">Click on a star to register your rating</p>
          <p class="has-text-weight-bold">Score Meaning</p>
          <div v-if="score !== null">
            <div v-if="score >= 4">
              <p class="has-text-success has-text-weight-bold is-size-4">Very Valuable</p>
              <p>We don't think we'll need additional support.</p>
            </div>
            <div v-else-if="score >= 2">
              <p class="has-text-warning has-text-weight-bold is-size-4">Somewhat Valuable</p>
              <p>We might need additional support.</p>
            </div>
            <div v-else-if="score >= 1">
              <p class="has-text-danger has-text-weight-bold is-size-4">Not Valuable</p>
              <p>We will definitely need additional support.</p>
            </div>
          </div>
          <div v-else>
            <p class="has-text-grey-light">Please select a rating</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Navigate -->
    <div class="py-lg">
      <div class="columns is-centered">
        <div class="column">
          <b-button
            type="is-light rounded-lg"
            size="is-medium"
            @click="goBack"
            expanded
            ><b-icon icon="arrow-left"></b-icon>
          </b-button>
        </div>
        <div class="column">
          <b-button
            type="is-primary rounded-lg"
            size="is-medium"
            expanded
            :disabled="!ready || saving"
            :loading="saving"
            @click="goForward"
          >Continue</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {

  },
  computed: {
    ...mapGetters(['app', 'context']),
    body () {
      const body = {
        metadata: [{
          name: 'ob_feedback_support',
          display_name: 'Onboarding Feedback: Support',
          type: 'string',
          value: this.score
        }]
      }
      return body
    },
    ready () {
      return (this.score)
    }
  },
  data () {
    return {
      saving: false,
      score: null
    }
  },
  methods: {
    goBack () {
      this.$emit('navigate', 'Intro')
    },
    goForward () {
      this.saving = true
      const endpoint = this.context.route + '/'
      this.$http.patch(endpoint, this.body).then(() => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Thank you!' })
        this.$emit('metadata:saved')
        this.$emit('navigate', 'Platform')
      }).finally(() => {
        this.saving = false
      })
    }
  },
  mounted () {
    if ('ob_feedback_support' in this.brand.metadata) {
      this.score = parseInt(this.brand.metadata.ob_feedback_support.values[0].value)
    }
  },
  props: {
    connection: {
      type: Object,
      required: true
    },
    task: {
      type: Object,
      required: true
    },
    brand: {
      type: Object,
      required: true
    }
  }
}
</script>
